import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Container } from '@mui/system';
import { useTranslation } from 'react-i18next';
import ETHIcon from '../../../assets/etc_icon_services.png'
import ChangeCryptoEachOtherIcon from '../../../assets/deposit_harvest_icon.png'
import CashIcon from '../../../assets/cash.png'
import BitcoinIcon from '../../../assets/biticon.png'
import WalletIcon from '../../../assets/change.png'
import FastServices from '../../../assets/fast-services.png'
import './Services.css'
import { Box } from '@mui/material';

export function Services() {
    const { t } = useTranslation();
    return (

        <Paper elevation={0} sx={{ borderRadius: 0, mx: 0, px: 0, bgcolor: 'background.default' }}>
            <Container>
                <Stack direction="column" sx={{ py: 5 }}>
                    <Grid mb={1.5}>
                        <Stack direction={'row'} mb={2} spacing={4} justifyContent={'center'} alignItems={'center'}>
                            <div style={{ background: 'linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)', width: '130px', height: '1px' }}></div>
                            <Typography variant='h4' sx={{ textAlign: 'center', mb: 2 }}>{t('rabsana_services')}</Typography>
                            <div style={{ background: 'linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)', transform: 'rotate(-180deg)', width: '130px', height: '1px' }}></div>
                        </Stack>
                        <Typography variant='subtitle1' sx={{ textAlign: 'center', mb: 2, color: 'text.title' }}>
                            بخشی از خدماتی که در پارسیان بیت ارائه می دهیم
                        </Typography>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} p={1} >
                            <Card sx={{ borderRadius: '10px', pt: 3, bgcolor: 'background.cardsHome' }} className='services_card'>
                                <CardContent>
                                    <Grid container justifyContent="center" sx={{ mb: 2 }} className='parent_img_cards_services'>
                                        <Box className='img_cards_services'>
                                            <img src={BitcoinIcon} alt='icon' width='auto' />
                                        </Box>
                                    </Grid>
                                    <Typography gutterBottom variant='h5' sx={{ textAlign: 'center', mb: 1 }}>
                                        {t('buy_sell_crypto')}
                                    </Typography>
                                    <Typography color="text.secondary" sx={{ textAlign: 'center' }}>
                                        ما در پارسیان بیت از تعداد زیادی رمزارز پشتیبانی می کنیم
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1} >
                            <Card sx={{ borderRadius: '10px', pt: 3, bgcolor: 'background.cardsHome' }} className='services_card'>
                                <CardContent>
                                    <Grid container justifyContent="center" sx={{ mb: 2 }} className='parent_img_cards_services'>
                                        <Box className='img_cards_services'>
                                            <img src={ETHIcon} alt='icon' width='auto' style={{borderRadius:'50%'}} />
                                        </Box>
                                    </Grid>
                                    <Typography gutterBottom variant='h5' sx={{ textAlign: 'center', mb: 1 }}>
                                        {t('elctroninc_crypto')}
                                    </Typography>
                                    <Typography color="text.secondary" sx={{ textAlign: 'center' }}>
                                        شما می توانید علاوه بر رمزارزها، ارزهای الکترونیکی را نیز در پارسیان بیت خریداری کنید
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1} >
                            <Card sx={{ borderRadius: '10px', pt: 3, bgcolor: 'background.cardsHome' }} className='services_card'>
                                <CardContent>
                                    <Grid container justifyContent="center" sx={{ mb: 2 }} className='parent_img_cards_services'>
                                        <Box className='img_cards_services'>
                                            <img src={ChangeCryptoEachOtherIcon} alt='icon' width='auto' />
                                        </Box>
                                    </Grid>
                                    <Typography gutterBottom variant='h5' sx={{ textAlign: 'center', mb: 1 }}>
                                        {t('change_each_other')}
                                    </Typography>
                                    <Typography color="text.secondary" sx={{ textAlign: 'center' }}>
                                        در پارسیان بیت می توانید با کمترین کارمزد رمزارزهایتان را به یکدیگر تبدیل کنید
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1} >
                            <Card sx={{ borderRadius: '10px', pt: 3, bgcolor: 'background.cardsHome' }} className='services_card'>
                                <CardContent>
                                    <Grid container justifyContent="center" sx={{ mb: 2 }} className='parent_img_cards_services'>
                                        <Box className='img_cards_services'>
                                            <img src={CashIcon} alt='icon' width='auto' />
                                        </Box>
                                    </Grid>
                                    <Typography gutterBottom variant='h5' sx={{ textAlign: 'center', mb: 1 }}>
                                        {t('cash')}
                                    </Typography>
                                    <Typography color="text.secondary" sx={{ textAlign: 'center' }}>
                                        اگر درآمد دلاری دارید و می خواهید آن را نقد کنید ما به شما کمک می کنیم
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1} >
                            <Card sx={{ borderRadius: '10px', pt: 3, bgcolor: 'background.cardsHome' }} className='services_card'>
                                <CardContent>
                                    <Grid container justifyContent="center" sx={{ mb: 2 }} className='parent_img_cards_services'>
                                        <Box className='img_cards_services'>
                                            <img src={WalletIcon} alt='icon' width='auto' />
                                        </Box>

                                    </Grid>
                                    <Typography gutterBottom variant='h5' sx={{ textAlign: 'center', mb: 1 }}>
                                        {t('wallet_hold')}
                                    </Typography>
                                    <Typography color="text.secondary" sx={{ textAlign: 'center' }}>
                                        شما می توانید دارایی رمزارزی تان را در کیف پول های امن پارسیان بیت نگه داری کنید
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1} >
                            <Card sx={{ borderRadius: '10px', pt: 3, bgcolor: 'background.cardsHome' }} className='services_card'>
                                <CardContent>
                                    <Grid container justifyContent="center" sx={{ mb: 2 }} className='parent_img_cards_services'>
                                        <Box className='img_cards_services'>
                                            <img src={FastServices} alt='icon' width='auto' />
                                        </Box>
                                    </Grid>
                                    <Typography gutterBottom variant='h5' sx={{ textAlign: 'center', mb: 1 }}>
                                        {t('fast_services')}
                                    </Typography>
                                    <Typography color="text.secondary" sx={{ textAlign: 'center' }}>
                                        خرید و فروش رمزارزها و تسویه ریالی آنها بصورت خودکار و در سریع ترین زمان انجام می شود
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Stack>
            </Container>
        </Paper>

    );
}
